import { render, staticRenderFns } from "./status-card.component.vue?vue&type=template&id=15c88624"
import script from "./status-card.component.ts?vue&type=script&lang=ts&external"
export * from "./status-card.component.ts?vue&type=script&lang=ts&external"
import style0 from "./status-card.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports